import React, { useState, useEffect } from 'react';
import { AlertTriangle, Sparkles, BrainCircuit } from 'lucide-react';

const CoachFatigueAlert = ({ athleteId, athleteName, readinessScore, recentStatus }) => {
  const [analysis, setAnalysis] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFatigueAnalysis = async () => {
      setLoading(true);
      try {
        if (athleteId.startsWith('demo-')) {
          setTimeout(() => {
            setAnalysis(athleteId === 'demo-1' ? 'El atleta Carlos Demo se encuentra en Fatiga Alta. Las métricas recientes indican una baja VFC (30ms) y un descanso pobre, sugiriendo una alta carga en el sistema simpático. Considera reducir el volumen aeróbico.' : 'El atleta muestra un estado de riesgo moderado o en recuperación. Es prudente monitorizar.');
            setLoading(false);
          }, 1500);
          return;
        }

        const API_URL = import.meta.env.VITE_API_URL || (window.location.hostname === 'localhost' ? 'http://localhost:3000/api' : '/api');
        const res = await fetch(`${API_URL}/ai/coach-fatigue-analysis?userId=${athleteId}`, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        });
        const data = await res.json();
        if (data && data.analysis) {
          setAnalysis(data.analysis);
        } else {
          setAnalysis('No se pudo generar el análisis de fatiga.');
        }
      } catch (e) {
        console.error(e);
        setAnalysis('Error de conexión al obtener el diagnóstico IA.');
      } finally {
        setLoading(false);
      }
    };

    if (athleteId) {
      fetchFatigueAnalysis();
    }
  }, [athleteId]);

  return (
    <div style={{
      background: 'linear-gradient(135deg, rgba(239, 68, 68, 0.1) 0%, rgba(245, 158, 11, 0.1) 100%)',
      border: '1px solid rgba(239, 68, 68, 0.3)',
      borderRadius: '16px',
      padding: '1.5rem',
      gridColumn: '1 / -1', // span full width if in a grid
      boxShadow: '0 8px 32px rgba(239, 68, 68, 0.1)',
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem',
      animation: 'fadeInTab 0.5s ease-out',
      marginBottom: '1rem'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '1rem' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
          <div style={{ background: 'rgba(239, 68, 68, 0.2)', color: '#ef4444', padding: '0.5rem', borderRadius: '12px' }}>
            <AlertTriangle size={24} />
          </div>
          <div>
            <h3 style={{ margin: 0, color: '#ef4444', fontSize: '1.2rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              Diagnóstico de Triage <Sparkles size={16} />
            </h3>
            <p style={{ margin: 0, color: 'rgba(255,255,255,0.7)', fontSize: '0.85rem' }}>
              Readiness: <strong style={{ color: '#fff' }}>{readinessScore || 0}%</strong> · Estado: <strong style={{ color: '#fff' }}>{recentStatus || 'Desconocido'}</strong>
            </p>
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', background: 'rgba(0,0,0,0.3)', padding: '0.4rem 0.8rem', borderRadius: '20px', fontSize: '0.8rem', color: '#a78bfa' }}>
          <BrainCircuit size={16} /> Copiloto IA
        </div>
      </div>

      <div style={{ background: 'rgba(0,0,0,0.2)', borderRadius: '12px', padding: '1rem', position: 'relative', overflow: 'hidden' }}>
        {loading ? (
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <div className="spinner" style={{ width: '20px', height: '20px', border: '2px solid rgba(255,255,255,0.1)', borderTopColor: '#ef4444', borderRadius: '50%', animation: 'spin 1s linear infinite' }}></div>
            <span style={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.9rem' }}>La IA de Nous está analizando las causas fisiológicas...</span>
          </div>
        ) : (
          <p style={{ margin: 0, color: 'rgba(255,255,255,0.9)', fontSize: '0.95rem', lineHeight: '1.6', whiteSpace: 'pre-wrap' }}>
            {analysis}
          </p>
        )}
      </div>
      
      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default CoachFatigueAlert;
